import { createFilterOptions } from '@mui/material';
import { TAutocompleteOption } from '~/components/AutocompleteField/types';

export const muiFilter = createFilterOptions<TAutocompleteOption>();

export function getRelevanceScore(label: string, input: string): number {
  const normalizedLabel = label.toLowerCase();
  const normalizedInput = input.toLowerCase();
  if (normalizedLabel.startsWith(normalizedInput)) return 0;
  if (normalizedLabel.includes(normalizedInput)) return 1;
  return 2;
}

export function sortByRelevance(
  options: TAutocompleteOption[],
  inputValue: string
): TAutocompleteOption[] {
  if (!inputValue) return options;

  return [...options].sort((a, b) => {
    const scoreA = getRelevanceScore(a.label ?? '', inputValue);
    const scoreB = getRelevanceScore(b.label ?? '', inputValue);
    if (scoreA !== scoreB) return scoreA - scoreB;
    return (a.label ?? '').localeCompare(b.label ?? '');
  });
}
